<template>
  <div class="punch-card-preview-container d-flex align-items-center justify-content-center position-relative">
    <img src="@/assets/images/phone-preview.png" alt="Punch Card Preview" class="img-fluid position-relative">
    <div class="phone-canvas position-absolute d-flex flex-column"
      :style="{ 'background-image': campaignData.design.customize.campaign_background_image ? `url(${campaignData.design.customize.campaign_background_image})` : null }">
      <div
        :class="['browser-container d-inline-flex flex-column align-items-center flex-grow-1 mx-auto w-100', { 'px-1 py-3 justify-content-center': campaignData.design.customize.campaign_layout === 1, 'justify-content-between': campaignData.design.customize.campaign_layout === 2 }]">
        <div
          :class="['card-container d-flex flex-column', { 'py-1 mt-5': campaignData.design.customize.campaign_layout === 2 }]"
          :style="{ 'background-color': campaignData.design.customize.campaign_card_color }">
          <template v-if="campaignData.design.customize.campaign_layout === 1">
            <div class="brand-logo-container flex-shrink-0 mt-3 mb-2">
              <img v-if="campaignData.design.customize.image" :src="campaignData.design.customize.image"
                alt="Brand Logo" class="img-fluid" width="80">
              <img v-else src="@/assets/images/rush-logo.png" alt="Brand Logo" class="img-fluid" width="80">
            </div>
            <p class="campaign-name mb-1 px-2 overflow-hidden text-truncate flex-shrink-0">{{ campaignData.details.name
              }}</p>
          </template>
          <div class="p-2 flex-grow-1 overflow-hidden">
            <b-row v-for="(row, rowIndex) in chunkedStampsArray" :key="`row-stamps-${rowIndex}`" no-gutters
              class="mb-1">
              <b-col v-for="(col, colIndex) in row" :key="`col-stamps-${colIndex}`" class="col-4 p-0">
                <div
                  :class="['stamp-item d-inline-flex align-items-center justify-content-center position-relative', { 'earned': !rowIndex && !colIndex }]">
                  <span class="position-absolute w-100 h-100 d-inline-flex align-items-center justify-content-center">
                    <span v-if="colIndex === 0 && getReward(colIndex * rowIndex + 1 + rowIndex * 3)"
                      class="reward-label text-uppercase overflow-hidden text-truncate px-1">
                      {{ `Free ${getReward(colIndex * rowIndex + 1 + rowIndex * 3)}` }}
                    </span>
                    <span v-else-if="getReward(colIndex + 1 + rowIndex * 3)"
                      class="reward-label text-uppercase overflow-hidden text-truncate px-1">
                      {{ `Free ${getReward(colIndex + 1 + rowIndex * 3).reward.name}` }}
                    </span>
                    <span
                      v-if="colIndex + 1 + rowIndex * 3 === Number(campaignData.design.number_of_stamps) && mainReward"
                      class="reward-label text-uppercase overflow-hidden text-truncate px-1">
                      {{ `Free ${mainReward.reward.name}` }}
                    </span>
                  </span>
                  <img v-if="campaignData.design.stamp_icon" :src="campaignData.design.stamp_icon" alt="Stamp Icon"
                    :class="{ uploaded: campaignData.design.stamp_preset === 'custom' }">
                </div>
              </b-col>
            </b-row>
          </div>
          <div
            class="text-primary font-weight-bold px-2 py-1 align-self-end justify-self-end d-inline-flex align-items-center">
            See Details
            <img src="@/assets/images/icons/punch-card/flip.png" alt="Flip" width="15" class="ml-1">
          </div>
        </div>

        <div class="card-layout-2 rounded-top w-100 mt-3 p-2 py-1 d-flex align-items-center"
          :style="{ 'background-color': campaignData.design.customize.campaign_card_color }"
          v-if="campaignData.design.customize.campaign_layout === 2">
          <div class="brand-logo-container">
            <img v-if="campaignData.design.customize.image" :src="campaignData.design.customize.image" alt="Brand Logo"
              class="img-fluid" width="80">
            <img v-else src="@/assets/images/rush-logo.png" alt="Brand Logo" class="img-fluid" width="80">
          </div>
          <p class="campaign-name flex-grow-1 mb-0 text-left pl-1 overflow-hidden text-truncate">{{
            campaignData.details.name }}
          </p>
        </div>
      </div>
      <div class="phone-address-bar bg-white align-self-end w-100 p-3">
        <div class="rounded bg-light d-flex justify-content-between">
          <span class="mx-1">
            <span class="small-text">A</span>
            <span class="large-text">A</span>
          </span>
          <span><i class="bi bi-lock-fill mr-2" aria-hidden="true"></i>rush.ph</span>
          <i class="bi bi-arrow-clockwise mx-1" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, getCurrentInstance } from "@vue/composition-api";
import { mapState } from "vuex";
import _ from "lodash";

export default defineComponent({
  computed: {
    ...mapState("punchCard", ["campaignData"])
  },
  mounted() {
    this.$root.$on("forceUpdate", () => this.$forceUpdate());
  },
  beforeDestroy() {
    this.$root.$off("forceUpdate");
  },
  setup() {
    const currentInstance = getCurrentInstance();

    const stampRewardsArray = computed(() => Array.from({ length: Number(currentInstance.proxy.campaignData.design.number_of_stamps) }, (_, i) => i + 1));

    const chunkedStampsArray = computed(() => _.chunk(stampRewardsArray.value, 3));

    const mainReward = computed(() => currentInstance.proxy.campaignData.design.milestones.find(({ is_main }) => is_main) || null);

    const getReward = (count) => {
      return computed(() => currentInstance.proxy.campaignData.design.milestones.find(({ stamps_count }) => Number(stamps_count) === Number(count))).value;
    };

    return {
      stampRewardsArray,
      chunkedStampsArray,
      mainReward,
      getReward
    }
  }
})
</script>

<style lang="scss" scoped>
.punch-card-preview-container {
  &>img {
    z-index: 9;
  }

  .phone-canvas {
    width: 180px;
    height: 382px;
    background-color: #fff;
    background-size: cover !important;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .browser-container {
    overflow-y: hidden;
  }

  .card-container {
    width: 80%;
    max-height: 90%;
    height: 100%;
    overflow-y: hidden;
    border-radius: 6px;

    .stamp-item {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background-color: #fff;
      border: solid 1px #8B959F;
      transition: all 0.2s ease;
      overflow: hidden;

      &>img {
        width: 80%;
        opacity: 0.3;

        &.uploaded {
          width: 65%;
        }
      }

      &.earned {
        &>img {
          opacity: 1;
        }
      }

      .reward-label {
        font-size: 7px;
        color: #FF6B00;
        font-family: MainFontBold, sans-serif;
        line-height: 1;
        background-color: rgba(255, 255, 255, 0.5) !important;
      }
    }
  }

  .brand-logo-container {
    height: 40px;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &>img {
      object-fit: fill;
    }
  }

  .campaign-name {
    font-family: MainFontBold, sans-serif;
  }

  .card-layout-2 {
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;

    .brand-logo-container {
      height: unset;
      max-width: 50px;
    }
  }

  .phone-address-bar {
    backdrop-filter: blur(5px);

    .small-text,
    .large-text {
      font-family: MainFontBold, sans-serif;

      &:not(.large-text) {
        font-size: 9px;
      }
    }
  }
}
</style>
